// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WhatsappCTA_wrapper__2mw6B"};